// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { WeddingRingFiltersFragmentDoc } from '../../../graphql/api/product/rings/wedding/fragments/WeddingRingFilters.fragment.generated';
import { ProductGridFragmentDoc } from '../../../components/rings/product-grid/ProductGrid.generated';
import { ProductPageFacetedContentFragmentDoc } from '../../../graphql/api/product/faceted-content/productPageFacetedContent.fragment.generated';
import { ProductPageListingFragmentDoc } from '../../../graphql/api/cms/pageProductListing.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const WeddingRingBrowseDocument = gql`
    query weddingRingBrowse($currency: CurrencyInput!, $region: RegionCode!, $filter: CatalogueWeddingRingFilterInput!, $page: Int!, $locale: Locale!, $limit: Int!, $facetedContentInput: ProductPageFacetedContentInput!, $sortBy: CatalogueSortOrder!) {
  catalogueWeddingRingFilters(input: $filter) {
    ...weddingRingFilters
  }
  catalogueWeddingRingsAggregate(filter: $filter) {
    count
  }
  catalogueWeddingRings(
    filter: $filter
    pagination: {page: $page, limit: $limit}
    sort: {currency: $currency, by: $sortBy}
  ) {
    ...productGrid
  }
  pageProductListingFacetedContent(input: $facetedContentInput, locale: $locale) {
    ...productPageFacetedContent
  }
}
    ${WeddingRingFiltersFragmentDoc}
${ProductGridFragmentDoc}
${ProductPageFacetedContentFragmentDoc}`;

export function useWeddingRingBrowseQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.WeddingRingBrowseQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.WeddingRingBrowseQuery, SchemaTypes.WeddingRingBrowseQueryVariables | undefined>({ query: WeddingRingBrowseDocument, variables: undefined, ...options });
};
export const WeddingRingBrowseContentDocument = gql`
    query weddingRingBrowseContent($locale: Locale!, $path: String!, $region: RegionCode!, $currency: CurrencyInput!) {
  pageProductListing(path: $path, locale: $locale) {
    ...productPageListing
  }
}
    ${ProductPageListingFragmentDoc}`;

export function useWeddingRingBrowseContentQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.WeddingRingBrowseContentQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.WeddingRingBrowseContentQuery, SchemaTypes.WeddingRingBrowseContentQueryVariables | undefined>({ query: WeddingRingBrowseContentDocument, variables: undefined, ...options });
};